import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from "@tanstack/react-query";
import { getNotificationHistory, getUnreadNotificationCount, markNotificationAsRead } from "../../core/services/notification";
export const NOTIFICATION_QUERY_KEYS = {
    all: (isPortal) => ["notifications", isPortal ? "portal" : "backoffice"],
    history: (page, size, isPortal) => [...NOTIFICATION_QUERY_KEYS.all(isPortal), "history", page, size],
    unreadCount: (isPortal) => [...NOTIFICATION_QUERY_KEYS.all(isPortal), "unread-count"],
};
export const useNotificationHistory = (page = 0, size = 10, enabled = true, isPortal = false) => {
    return useQuery({
        queryKey: NOTIFICATION_QUERY_KEYS.history(page, size, isPortal),
        queryFn: () => getNotificationHistory(page, size, isPortal),
        refetchInterval: 30000, // Auto refetch every 30 seconds
        enabled,
    });
};
export const useUnreadNotificationCount = (enabled = true, isPortal = false) => {
    return useQuery({
        queryKey: NOTIFICATION_QUERY_KEYS.unreadCount(isPortal),
        queryFn: () => getUnreadNotificationCount(isPortal),
        refetchInterval: 30000,
        enabled,
    });
};
export const useMarkNotificationAsRead = (isPortal = false) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => markNotificationAsRead(id, isPortal),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: NOTIFICATION_QUERY_KEYS.all(isPortal) });
        },
    });
};
export const useMarkAllNotificationsAsRead = (isPortal = false) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => import("../../core/services/notification").then(m => m.markAllNotificationsAsRead(isPortal)),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: NOTIFICATION_QUERY_KEYS.all(isPortal) });
        },
    });
};
export const useInfiniteNotificationHistory = (size = 10, isPortal = false) => {
    return useInfiniteQuery({
        queryKey: [...NOTIFICATION_QUERY_KEYS.all(isPortal), "infinite", size],
        queryFn: ({ pageParam = 0 }) => getNotificationHistory(pageParam, size, isPortal),
        getNextPageParam: (lastPage) => {
            if (!lastPage?.paging)
                return undefined;
            const nextPage = (lastPage.paging.currentPage ?? 0) + 1;
            return nextPage < (lastPage.paging.totalPage ?? 0) ? nextPage : undefined;
        },
        initialPageParam: 0,
    });
};
